import { layoutTypes } from './notification.types';

export const setUpdateNotification = (flag: boolean) => ({
  type: layoutTypes.UPDATE,
  payload: flag,
});
